module.exports = __webpack_public_path__ + "img/blessing_prize_3.50d87925.png";